import InvestRatingPageNew from './InvestRatingPageNew';

export default InvestRatingPageNew;
